import { Http } from '@/lib/http';

export class SuspiciousBehaviourService extends Http {
  constructor() {
    super();
    this.endpoint = '/aml-pro/settings/suspicious-behaviors/';
  }

  fetchAll()       { return this.httpClient().get(this.endpoint); }
  create(data)     { return this.httpClient().post(this.endpoint, { suspiciousBehaviour: String(data.suspiciousBehaviour || ''), code: String(data.code || '') }); }
  update(id, data) { return this.httpClient().patch(`${this.endpoint}${id}`, { suspiciousBehaviour: String(data.suspiciousBehaviour || ''), code: String(data.code || '') }); }
  delete(id)       { return this.httpClient().delete(`${this.endpoint}${id}`); }
}